var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatePenX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x9A\x99\xEF\xB8\x8F Icon / Variants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4555 1.71848C17.399 0.774943 18.9653 0.743382 19.9088 1.72676L21.684 3.502C22.6674 4.44549 22.6359 6.01182 21.6923 6.95536L11.031 17.6167C10.869 17.7787 10.6563 17.8801 10.4285 17.9041L7.03496 18.2613C5.94648 18.3958 5.01499 17.4644 5.14947 16.3759L5.50669 12.9823C5.53067 12.7545 5.63213 12.5418 5.79411 12.3798L16.4555 1.71848ZM17.8698 3.1328C18.0575 2.94505 18.3346 2.9733 18.4673 3.11344C18.4735 3.11998 18.4798 3.12643 18.4862 3.1328L20.278 4.92462C20.2844 4.93099 20.2908 4.93728 20.2974 4.94347C20.4375 5.07623 20.4658 5.35328 20.278 5.54103L19.3128 6.50624L16.9046 4.09801L17.8698 3.1328ZM15.4903 5.51233L17.8985 7.92056L9.86702 15.952L7.17547 16.2353L7.45879 13.5438L15.4903 5.51233Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59098 5.04072C3.59098 4.48839 4.03873 4.04064 4.59105 4.04064H11.4805C12.0328 4.04064 12.4806 3.59289 12.4806 3.04056C12.4806 2.48824 12.0328 2.04049 11.4805 2.04049H4.59105C2.93407 2.04049 1.59082 3.38374 1.59082 5.04072V18.8196C1.59082 20.4766 2.93407 21.8198 4.59106 21.8198H18.3699C20.0269 21.8198 21.3701 20.4766 21.3701 18.8196V11.9301C21.3701 11.3778 20.9224 10.9301 20.3701 10.9301C19.8177 10.9301 19.37 11.3778 19.37 11.9301V18.8196C19.37 19.3719 18.9222 19.8197 18.3699 19.8197H4.59106C4.03873 19.8197 3.59098 19.3719 3.59098 18.8196V5.04072Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePenX2);
export default __webpack_public_path__ + "static/media/CreatePenX2.2b9783a208eff455d60b2f0db2b2bf9d.svg";
export { ForwardRef as ReactComponent };